import * as React from 'react';
import './style';
import { AppRouter } from './AppRouter';
import { AppHeader } from './AppHeader';
import { User } from 'firebase/auth';
import { auth } from './firebase';

interface AppContext {
	user: User | null;
	setUser: React.Dispatch<React.SetStateAction<User | null>>;
	loading: boolean;
}

export const AppContextProvider = React.createContext<AppContext>({} as AppContext);

export default function App(): JSX.Element {
	const [user, setUser] = React.useState<User | null>(null);
	const [loading, setLoading] = React.useState<boolean>(true);

	React.useEffect(() => {
		const unsubscribe = auth.onAuthStateChanged((user) => {
			setUser(user);
			setLoading(false);
		});
		return () => unsubscribe();
	}, []);

	return (
		<AppContextProvider.Provider value={{
			user,
			setUser,
			loading
		}}>
			<div className="flex-vertical flex-fill dark-grey-background">
				<AppHeader />
				<AppRouter />
			</div>
		</AppContextProvider.Provider>
	);
}
